<template>
  <div class="chooose_group">
    <div class="layerWrap">
      <div class="layer"></div>
      <div class="group_3">
        <div class="infoWrap"><span class="info">请选择课题组</span></div>
          <div class="block_researchgroup" v-for="(researchGroup,index) in researchGroupDetailList" :key=index>
            <label class="label-checkbox item-content">
              <input type="radio" class="radio-input-attr" :checked="researchGroup.researchGroupNo === displayChosenResearchGroup.researchGroupNo" name="attr" value="researchGroup.researchGroupName">
              <div class="item-media group" @click="updateResearchGroup(index)">
                <i class="icon icon-form-checkbox i-style"></i>
                <span class="info_2">{{researchGroup.researchGroupName}}</span>
              </div>
            </label>
          </div>
        <div class="block_3">
          <div class="tagWrap research-background-color" @click="updateChosenResearchGroup()"><span class="tag">切换课题组</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
export default {
  data () {
    return {
      constants: {},
      index: 0
    }
  },
  mounted () {
    this.index = this.chosenResearchGroupIndex
  },
  computed: {
    ...mapGetters([
      'researchGroupDetailList', 'displayChosenResearchGroup'
    ]),
    ...mapState([
      'chosenResearchGroupIndex'
    ])
  },
  methods: {
    ...mapMutations([
      'UPDATE_CHOSEN_RESEARCH_INDEX'
    ]),
    updateResearchGroup (index) {
      this.index = index
    },
    updateChosenResearchGroup () {
      this.UPDATE_CHOSEN_RESEARCH_INDEX(this.index)
      this.$emit('toggleShow')
    }
  }
}
</script>
<style scoped>
.chooose_group {
  position: fixed;
  top: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}

.layerWrap {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.layer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10600;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .4);
  opacity: 1;
  -webkit-transition-duration: 400ms;
  -o-transition-duration: 400ms;
  transition-duration: 400ms;
}

.group_3 {
  display: flex;
  /*position: absolute;*/
  /*top: 60vw;*/
  /*left: 13.33vw;*/
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 73.33vw;
  padding: 6vw 0;
  z-index: 10601;
  /* height: 73.6vw; */
}

.infoWrap {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 73.07vw;
}

.info {
  opacity: 1;
  max-width: 69.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 6.67vw;
  white-space: nowrap;
  color: #424242;
  font-size: 4.8vw;
  font-weight: bold;
}

.block_researchgroup {
  display: flex;
  flex-direction: row;
  margin-top: 4.8vw;
  padding-left: 17.86vw;
}

.info_2 {
  opacity: 1;
  margin-left: 1.87vw;
  max-width: 47.47vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #929292;
  font-size: 4.27vw;
  font-weight: 400;
}

.group {
  display: flex;
  flex-direction: row;
  /* margin-top: 5.6vw; */
  /*margin-left: 17.86vw*/
}

.block_3 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 6.67vw;
  width: 73.07vw;
}

.tagWrap {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  padding-right: 20.8vw;
  padding-left: 20.8vw;
  height: 13.33vw;
  margin-right: 12vw;
}

.tag {
  opacity: 1;
  text-align: center;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}

label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox:after {
  background: no-repeat center;
  background-image: url('/static/img/tick.png');
  background-size: .6rem .45rem;
}

label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
}

label.label-checkbox input[type=radio]:checked+.item-media .info_2 {
  opacity: 1;
  margin-left: 1.87vw;
  max-width: 47.47vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #5878fa;
  font-size: 4.27vw;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// ChooseResearchGroup.vue?160e2a36